/**
 * Видео-гайды — короткие ролики по экранам рижского интерфейса.
 *
 * Файлы лежат в `public/media/guides/` и уходят в образ вместе со сборкой: на
 * узле их отдаёт тот же nginx, что и SPA (`location /media/` в
 * `deploy/nginx/conf.d/riga.conf`). Префикс `/media/`, а не `/guides/`, —
 * чтобы адрес файла не пересекался с адресом экрана `/guides/<id>`.
 *
 * Новый гайд: mp4 и обложка в `public/media/guides/`, запись в `GUIDES`.
 * Исходники роликов и их сборка — `video/<id>/` в корне проекта, вне
 * `riga-app` (там же — откуда взяты тайм-коды глав).
 */

export interface GuideChapter {
	/** Начало главы, секунды. */
	at: number
	title: string
}

export interface Guide {
	/** Часть адреса: `/guides/<id>`. */
	id: string
	title: string
	summary: string
	/** Длина для списка — чтобы не ждать метаданных каждого файла. */
	duration: string
	video: string
	poster: string
	/** Экран, о котором гайд, — ссылка под плеером. */
	screen: { label: string; to: string }
	chapters: GuideChapter[]
}

/** Скорости переключателя. Браузер умеет и больше, но выше 2× подписи
 *  в роликах прочитать уже нельзя. */
export const SPEEDS = [1, 1.25, 1.5, 1.75, 2]

export const GUIDES: Guide[] = [
	{
		id: "perevody",
		title: "Справочник переводов: как перевести фразы на другой язык",
		summary:
			"Цикл из трёх шагов: собрать новые фразы, перевести их через DeepL и проверить, применить переводы к базе.",
		duration: "2:01",
		video: "/media/guides/perevody.mp4",
		poster: "/media/guides/perevody.jpg",
		screen: { label: "Справочник переводов", to: "/translate/dictionary" },
		// начала шагов — из таймлайна ролика (`video/perevody/build.py`, `step()`)
		chapters: [
			{ at: 6.5, title: "Где экран и что выбрать" },
			{ at: 20.2, title: "Шаг 1. Собрать новые фразы" },
			{ at: 41.5, title: "Шаг 2. Перевести и сохранить" },
			{ at: 87.0, title: "Шаг 3. Применить к базе" },
			{ at: 111.9, title: "Коротко" },
		],
	},
]
